module.exports = __webpack_public_path__ + "static/img/jigou-3-top.402a655.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou-3-top.png
// module id = 0Fgo
// module chunks = 2